var render = function () {
  var _vm$projectInfo, _vm$projectInfo2, _vm$projectInfo3, _vm$projectInfo3$lead, _vm$projectInfo3$lead2, _vm$projectInfo4, _vm$projectInfo4$lead, _vm$projectInfo4$lead2, _vm$projectInfo5, _vm$projectInfo6, _vm$projectInfo6$depa, _vm$projectInfo6$depa2, _vm$projectInfo7, _vm$projectInfo8, _vm$projectInfo9, _vm$leadLastActivityL, _vm$leadLastActivityL2, _vm$projectInfo10, _vm$projectInfo11, _vm$projectInfo12, _vm$projectInfo13, _vm$projectInfo14, _vm$projectInfo15, _vm$projectInfo16, _vm$projectInfo17, _vm$projectInfo18, _vm$projectInfo19, _vm$projectInfo20, _vm$projectInfo21, _vm$projectInfo22, _vm$projectInfo23, _vm$projectInfo24, _vm$projectInfo25, _vm$projectInfo26, _vm$projectInfo27, _vm$projectInfo28, _vm$projectInfo29, _vm$projectInfo30, _vm$projectInfo31, _vm$projectInfo32, _vm$projectInfo33, _vm$projectInfo34, _vm$projectInfo35, _vm$projectInfo36, _vm$projectInfo37, _vm$projectInfo38, _vm$projectInfo39, _vm$projectInfo40, _vm$projectInfo41, _vm$projectInfo42, _vm$projectInfo43, _vm$projectInfo44, _vm$projectInfo45, _vm$projectInfo45$lea, _vm$projectInfo45$lea2, _vm$projectInfo46, _vm$projectInfo46$lea, _vm$projectInfo46$lea2, _vm$projectInfo47, _vm$projectInfo47$lea, _vm$projectInfo47$lea2, _vm$projectInfo48, _vm$projectInfo48$lea, _vm$projectInfo48$lea2, _vm$projectInfo49, _vm$projectInfo49$lea, _vm$projectInfo49$lea2, _vm$projectInfo50, _vm$projectInfo50$lea, _vm$projectInfo50$lea2, _vm$projectInfo51, _vm$projectInfo51$lea, _vm$projectInfo51$lea2, _vm$projectInfo52, _vm$projectInfo52$lea, _vm$projectInfo52$lea2, _vm$projectInfo53, _vm$projectInfo53$lea, _vm$projectInfo53$lea2, _vm$projectInfo54, _vm$projectInfo54$lea, _vm$projectInfo54$lea2, _vm$projectInfo55, _vm$projectInfo55$lea, _vm$projectInfo55$lea2, _vm$projectInfo56, _vm$projectInfo56$lea, _vm$projectInfo56$lea2, _vm$projectInfo57, _vm$projectInfo57$lea, _vm$projectInfo57$lea2, _vm$projectInfo58, _vm$projectInfo58$lea, _vm$projectInfo58$lea2, _vm$projectInfo59, _vm$projectInfo59$lea, _vm$projectInfo59$lea2, _vm$projectInfo60, _vm$projectInfo60$lea, _vm$projectInfo60$lea2, _vm$projectInfo60$lea3, _vm$projectInfo63, _vm$projectInfo63$lea, _vm$projectInfo63$lea2, _vm$projectInfo64, _vm$projectInfo64$lea, _vm$projectInfo64$lea2, _vm$projectInfo65, _vm$projectInfo66, _vm$projectInfo66$cre, _vm$projectInfo67, _vm$projectInfo68, _vm$projectInfo69;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('div', {
    staticClass: "custom-search d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [((_vm$projectInfo = _vm.projectInfo) === null || _vm$projectInfo === void 0 ? void 0 : _vm$projectInfo.status) === false ? [_vm.$permissionAbility(_vm.PROJECT_APPROVE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "gradient-success"
    },
    on: {
      "click": _vm.approveProject
    }
  }, [_vm._v(" Approve ")])] : _vm._e(), _vm.$permissionAbility(_vm.PROJECT_EDIT, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "gradient-primary"
    },
    on: {
      "click": _vm.showProjectDetailsModal
    }
  }, [_vm._v(" Edit Project Details ")])] : _vm._e()] : _vm._e(), _vm.$permissionAbility(_vm.PROJECT_APPROVED_EDIT, _vm.permissions) && (_vm$projectInfo2 = _vm.projectInfo) !== null && _vm$projectInfo2 !== void 0 && _vm$projectInfo2.status ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "gradient-primary"
    },
    on: {
      "click": _vm.showApprovedProjectDetailsModal
    }
  }, [_vm._v(" Edit Approved Project Details ")])] : _vm._e()], 2)]), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12",
      "md": "12"
    }
  }, [_vm.approveErrorMsg ? [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v(_vm._s(_vm.approveErrorMsg) + "!")])])] : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "md": "4"
    }
  }, [_c('b-card', [_c('h4', [_vm._v("Project Details")]), _c('br'), _c('b-card-text', [_c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Title: "), (_vm$projectInfo3 = _vm.projectInfo) !== null && _vm$projectInfo3 !== void 0 && (_vm$projectInfo3$lead = _vm$projectInfo3.lead) !== null && _vm$projectInfo3$lead !== void 0 && (_vm$projectInfo3$lead2 = _vm$projectInfo3$lead.data) !== null && _vm$projectInfo3$lead2 !== void 0 && _vm$projectInfo3$lead2.title ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo4 = _vm.projectInfo) === null || _vm$projectInfo4 === void 0 ? void 0 : (_vm$projectInfo4$lead = _vm$projectInfo4.lead) === null || _vm$projectInfo4$lead === void 0 ? void 0 : (_vm$projectInfo4$lead2 = _vm$projectInfo4$lead.data) === null || _vm$projectInfo4$lead2 === void 0 ? void 0 : _vm$projectInfo4$lead2.title) + " ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Department: "), (_vm$projectInfo5 = _vm.projectInfo) !== null && _vm$projectInfo5 !== void 0 && _vm$projectInfo5.department ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo6 = _vm.projectInfo) === null || _vm$projectInfo6 === void 0 ? void 0 : (_vm$projectInfo6$depa = _vm$projectInfo6.department) === null || _vm$projectInfo6$depa === void 0 ? void 0 : (_vm$projectInfo6$depa2 = _vm$projectInfo6$depa.data) === null || _vm$projectInfo6$depa2 === void 0 ? void 0 : _vm$projectInfo6$depa2.name) + " ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Duration: "), (_vm$projectInfo7 = _vm.projectInfo) !== null && _vm$projectInfo7 !== void 0 && _vm$projectInfo7.time_duration ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo8 = _vm.projectInfo) === null || _vm$projectInfo8 === void 0 ? void 0 : _vm$projectInfo8.time_duration) + " Months ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Proposals: ")]), [_c('div', [(_vm$projectInfo9 = _vm.projectInfo) !== null && _vm$projectInfo9 !== void 0 && _vm$projectInfo9.proposal_url ? _c('b-link', {
    attrs: {
      "href": _vm.projectInfo.proposal_url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.projectInfo.proposal_filename) + " ")]) : (_vm$leadLastActivityL = _vm.leadLastActivityLog) !== null && _vm$leadLastActivityL !== void 0 && (_vm$leadLastActivityL2 = _vm$leadLastActivityL.file) !== null && _vm$leadLastActivityL2 !== void 0 && _vm$leadLastActivityL2.length ? [_c('ul', _vm._l(_vm.leadLastActivityLog.file, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('b-link', {
      attrs: {
        "href": item === null || item === void 0 ? void 0 : item.original_url,
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.file_name) + " ")])], 1);
  }), 0)] : _vm._e()], 2)]], 2), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Milestone: "), (_vm$projectInfo10 = _vm.projectInfo) !== null && _vm$projectInfo10 !== void 0 && _vm$projectInfo10.milestone ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo11 = _vm.projectInfo) === null || _vm$projectInfo11 === void 0 ? void 0 : _vm$projectInfo11.milestone) + " ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Extra Milestone: "), (_vm$projectInfo12 = _vm.projectInfo) !== null && _vm$projectInfo12 !== void 0 && _vm$projectInfo12.extra_milestone ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo13 = _vm.projectInfo) === null || _vm$projectInfo13 === void 0 ? void 0 : _vm$projectInfo13.extra_milestone) + " ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Total Milestone: "), (_vm$projectInfo14 = _vm.projectInfo) !== null && _vm$projectInfo14 !== void 0 && _vm$projectInfo14.total_milestone ? _c('b', [_vm._v(" " + _vm._s((_vm$projectInfo15 = _vm.projectInfo) === null || _vm$projectInfo15 === void 0 ? void 0 : _vm$projectInfo15.total_milestone) + " ")]) : _vm._e()])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Status: "), (_vm$projectInfo16 = _vm.projectInfo) !== null && _vm$projectInfo16 !== void 0 && _vm$projectInfo16.status ? [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-success"
    }
  }, [_vm._v("Approved")])] : ((_vm$projectInfo17 = _vm.projectInfo) === null || _vm$projectInfo17 === void 0 ? void 0 : _vm$projectInfo17.status) === false ? [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("Pending")])] : _vm._e()], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Project Type: "), _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatType((_vm$projectInfo18 = _vm.projectInfo) === null || _vm$projectInfo18 === void 0 ? void 0 : _vm$projectInfo18.project_type)))])], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Remarks: "), (_vm$projectInfo19 = _vm.projectInfo) !== null && _vm$projectInfo19 !== void 0 && _vm$projectInfo19.remarks ? [_vm._v(" " + _vm._s((_vm$projectInfo20 = _vm.projectInfo) === null || _vm$projectInfo20 === void 0 ? void 0 : _vm$projectInfo20.remarks) + " ")] : [_vm._v(" N/A ")]], 2)])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "md": "4"
    }
  }, [_c('b-card', [_c('h4', [_vm._v("Payment Details")]), _c('br'), _c('b-card-text', [_c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Amount: "), (_vm$projectInfo21 = _vm.projectInfo) !== null && _vm$projectInfo21 !== void 0 && _vm$projectInfo21.amount ? [_c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo22 = _vm.projectInfo) === null || _vm$projectInfo22 === void 0 ? void 0 : _vm$projectInfo22.amount,
      "currency": (_vm$projectInfo23 = _vm.projectInfo) === null || _vm$projectInfo23 === void 0 ? void 0 : _vm$projectInfo23.currency
    }
  })] : [_c('b', [_vm._v("0")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Total Amount: "), (_vm$projectInfo24 = _vm.projectInfo) !== null && _vm$projectInfo24 !== void 0 && _vm$projectInfo24.total_amount ? [_c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo25 = _vm.projectInfo) === null || _vm$projectInfo25 === void 0 ? void 0 : _vm$projectInfo25.total_amount,
      "currency": (_vm$projectInfo26 = _vm.projectInfo) === null || _vm$projectInfo26 === void 0 ? void 0 : _vm$projectInfo26.currency
    }
  })] : [_c('b', [_vm._v("0")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Extra Amount: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo27 = _vm.projectInfo) === null || _vm$projectInfo27 === void 0 ? void 0 : _vm$projectInfo27.extra_amount,
      "currency": (_vm$projectInfo28 = _vm.projectInfo) === null || _vm$projectInfo28 === void 0 ? void 0 : _vm$projectInfo28.extra_currency
    }
  })], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" VAT: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo29 = _vm.projectInfo) === null || _vm$projectInfo29 === void 0 ? void 0 : _vm$projectInfo29.vat_amount,
      "currency": (_vm$projectInfo30 = _vm.projectInfo) === null || _vm$projectInfo30 === void 0 ? void 0 : _vm$projectInfo30.currency
    }
  })], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Tax: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo31 = _vm.projectInfo) === null || _vm$projectInfo31 === void 0 ? void 0 : _vm$projectInfo31.tax_amount,
      "currency": (_vm$projectInfo32 = _vm.projectInfo) === null || _vm$projectInfo32 === void 0 ? void 0 : _vm$projectInfo32.currency
    }
  })], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Extra VAT & TAX: "), ((_vm$projectInfo33 = _vm.projectInfo) === null || _vm$projectInfo33 === void 0 ? void 0 : _vm$projectInfo33.extra_vat_amount) > 0 && ((_vm$projectInfo34 = _vm.projectInfo) === null || _vm$projectInfo34 === void 0 ? void 0 : _vm$projectInfo34.extra_tax_amount) > 0 ? [_c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo35 = _vm.projectInfo) === null || _vm$projectInfo35 === void 0 ? void 0 : _vm$projectInfo35.extra_vat_amount,
      "currency": (_vm$projectInfo36 = _vm.projectInfo) === null || _vm$projectInfo36 === void 0 ? void 0 : _vm$projectInfo36.currency
    }
  }), _vm._v(" & "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo37 = _vm.projectInfo) === null || _vm$projectInfo37 === void 0 ? void 0 : _vm$projectInfo37.extra_tax_amount,
      "currency": (_vm$projectInfo38 = _vm.projectInfo) === null || _vm$projectInfo38 === void 0 ? void 0 : _vm$projectInfo38.currency
    }
  })] : [_c('b', [_vm._v("0")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Total VAT: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo39 = _vm.projectInfo) === null || _vm$projectInfo39 === void 0 ? void 0 : _vm$projectInfo39.total_vat_amount,
      "currency": (_vm$projectInfo40 = _vm.projectInfo) === null || _vm$projectInfo40 === void 0 ? void 0 : _vm$projectInfo40.currency
    }
  })], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Total TAX: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo41 = _vm.projectInfo) === null || _vm$projectInfo41 === void 0 ? void 0 : _vm$projectInfo41.total_tax_amount,
      "currency": (_vm$projectInfo42 = _vm.projectInfo) === null || _vm$projectInfo42 === void 0 ? void 0 : _vm$projectInfo42.currency
    }
  })], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Grand Amount: "), _c('FormatCurrency', {
    attrs: {
      "amount": (_vm$projectInfo43 = _vm.projectInfo) === null || _vm$projectInfo43 === void 0 ? void 0 : _vm$projectInfo43.grand_amount,
      "currency": (_vm$projectInfo44 = _vm.projectInfo) === null || _vm$projectInfo44 === void 0 ? void 0 : _vm$projectInfo44.currency
    }
  })], 1)])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "md": "4"
    }
  }, [_c('b-card', [_c('h4', [_vm._v("Contact Details")]), _c('br'), _c('b-card-text', [_c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Key Contact Person: "), (_vm$projectInfo45 = _vm.projectInfo) !== null && _vm$projectInfo45 !== void 0 && (_vm$projectInfo45$lea = _vm$projectInfo45.lead) !== null && _vm$projectInfo45$lea !== void 0 && (_vm$projectInfo45$lea2 = _vm$projectInfo45$lea.data) !== null && _vm$projectInfo45$lea2 !== void 0 && _vm$projectInfo45$lea2.key_contact_person ? [_vm._v(" " + _vm._s((_vm$projectInfo46 = _vm.projectInfo) === null || _vm$projectInfo46 === void 0 ? void 0 : (_vm$projectInfo46$lea = _vm$projectInfo46.lead) === null || _vm$projectInfo46$lea === void 0 ? void 0 : (_vm$projectInfo46$lea2 = _vm$projectInfo46$lea.data) === null || _vm$projectInfo46$lea2 === void 0 ? void 0 : _vm$projectInfo46$lea2.key_contact_person))] : _vm._e()], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Company Name: "), (_vm$projectInfo47 = _vm.projectInfo) !== null && _vm$projectInfo47 !== void 0 && (_vm$projectInfo47$lea = _vm$projectInfo47.lead) !== null && _vm$projectInfo47$lea !== void 0 && (_vm$projectInfo47$lea2 = _vm$projectInfo47$lea.data) !== null && _vm$projectInfo47$lea2 !== void 0 && _vm$projectInfo47$lea2.company_name ? [_vm._v(" " + _vm._s((_vm$projectInfo48 = _vm.projectInfo) === null || _vm$projectInfo48 === void 0 ? void 0 : (_vm$projectInfo48$lea = _vm$projectInfo48.lead) === null || _vm$projectInfo48$lea === void 0 ? void 0 : (_vm$projectInfo48$lea2 = _vm$projectInfo48$lea.data) === null || _vm$projectInfo48$lea2 === void 0 ? void 0 : _vm$projectInfo48$lea2.company_name))] : _vm._e()], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Email Address: "), (_vm$projectInfo49 = _vm.projectInfo) !== null && _vm$projectInfo49 !== void 0 && (_vm$projectInfo49$lea = _vm$projectInfo49.lead) !== null && _vm$projectInfo49$lea !== void 0 && (_vm$projectInfo49$lea2 = _vm$projectInfo49$lea.data) !== null && _vm$projectInfo49$lea2 !== void 0 && _vm$projectInfo49$lea2.email ? [_c('b-link', {
    attrs: {
      "href": 'mailto:' + ((_vm$projectInfo50 = _vm.projectInfo) === null || _vm$projectInfo50 === void 0 ? void 0 : (_vm$projectInfo50$lea = _vm$projectInfo50.lead) === null || _vm$projectInfo50$lea === void 0 ? void 0 : (_vm$projectInfo50$lea2 = _vm$projectInfo50$lea.data) === null || _vm$projectInfo50$lea2 === void 0 ? void 0 : _vm$projectInfo50$lea2.email)
    }
  }, [_vm._v(" " + _vm._s((_vm$projectInfo51 = _vm.projectInfo) === null || _vm$projectInfo51 === void 0 ? void 0 : (_vm$projectInfo51$lea = _vm$projectInfo51.lead) === null || _vm$projectInfo51$lea === void 0 ? void 0 : (_vm$projectInfo51$lea2 = _vm$projectInfo51$lea.data) === null || _vm$projectInfo51$lea2 === void 0 ? void 0 : _vm$projectInfo51$lea2.email) + " ")])] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Website: "), (_vm$projectInfo52 = _vm.projectInfo) !== null && _vm$projectInfo52 !== void 0 && (_vm$projectInfo52$lea = _vm$projectInfo52.lead) !== null && _vm$projectInfo52$lea !== void 0 && (_vm$projectInfo52$lea2 = _vm$projectInfo52$lea.data) !== null && _vm$projectInfo52$lea2 !== void 0 && _vm$projectInfo52$lea2.website_link ? [_c('b-link', {
    attrs: {
      "href": 'https://' + ((_vm$projectInfo53 = _vm.projectInfo) === null || _vm$projectInfo53 === void 0 ? void 0 : (_vm$projectInfo53$lea = _vm$projectInfo53.lead) === null || _vm$projectInfo53$lea === void 0 ? void 0 : (_vm$projectInfo53$lea2 = _vm$projectInfo53$lea.data) === null || _vm$projectInfo53$lea2 === void 0 ? void 0 : _vm$projectInfo53$lea2.website_link),
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s((_vm$projectInfo54 = _vm.projectInfo) === null || _vm$projectInfo54 === void 0 ? void 0 : (_vm$projectInfo54$lea = _vm$projectInfo54.lead) === null || _vm$projectInfo54$lea === void 0 ? void 0 : (_vm$projectInfo54$lea2 = _vm$projectInfo54$lea.data) === null || _vm$projectInfo54$lea2 === void 0 ? void 0 : _vm$projectInfo54$lea2.website_link) + " ")])] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Contact Number: "), (_vm$projectInfo55 = _vm.projectInfo) !== null && _vm$projectInfo55 !== void 0 && (_vm$projectInfo55$lea = _vm$projectInfo55.lead) !== null && _vm$projectInfo55$lea !== void 0 && (_vm$projectInfo55$lea2 = _vm$projectInfo55$lea.data) !== null && _vm$projectInfo55$lea2 !== void 0 && _vm$projectInfo55$lea2.mobile ? [_c('b-link', {
    attrs: {
      "href": 'tel:' + ((_vm$projectInfo56 = _vm.projectInfo) === null || _vm$projectInfo56 === void 0 ? void 0 : (_vm$projectInfo56$lea = _vm$projectInfo56.lead) === null || _vm$projectInfo56$lea === void 0 ? void 0 : (_vm$projectInfo56$lea2 = _vm$projectInfo56$lea.data) === null || _vm$projectInfo56$lea2 === void 0 ? void 0 : _vm$projectInfo56$lea2.mobile)
    }
  }, [_vm._v(" " + _vm._s((_vm$projectInfo57 = _vm.projectInfo) === null || _vm$projectInfo57 === void 0 ? void 0 : (_vm$projectInfo57$lea = _vm$projectInfo57.lead) === null || _vm$projectInfo57$lea === void 0 ? void 0 : (_vm$projectInfo57$lea2 = _vm$projectInfo57$lea.data) === null || _vm$projectInfo57$lea2 === void 0 ? void 0 : _vm$projectInfo57$lea2.mobile) + " ")])] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Address: " + _vm._s((_vm$projectInfo58 = _vm.projectInfo) === null || _vm$projectInfo58 === void 0 ? void 0 : (_vm$projectInfo58$lea = _vm$projectInfo58.lead) === null || _vm$projectInfo58$lea === void 0 ? void 0 : (_vm$projectInfo58$lea2 = _vm$projectInfo58$lea.data) === null || _vm$projectInfo58$lea2 === void 0 ? void 0 : _vm$projectInfo58$lea2.address) + " ")])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Key Account Manager: "), (_vm$projectInfo59 = _vm.projectInfo) !== null && _vm$projectInfo59 !== void 0 && (_vm$projectInfo59$lea = _vm$projectInfo59.lead) !== null && _vm$projectInfo59$lea !== void 0 && (_vm$projectInfo59$lea2 = _vm$projectInfo59$lea.data) !== null && _vm$projectInfo59$lea2 !== void 0 && _vm$projectInfo59$lea2.accountManager ? [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('userCard', {
    attrs: {
      "user": (_vm$projectInfo60 = _vm.projectInfo) === null || _vm$projectInfo60 === void 0 ? void 0 : (_vm$projectInfo60$lea = _vm$projectInfo60.lead) === null || _vm$projectInfo60$lea === void 0 ? void 0 : (_vm$projectInfo60$lea2 = _vm$projectInfo60$lea.data) === null || _vm$projectInfo60$lea2 === void 0 ? void 0 : (_vm$projectInfo60$lea3 = _vm$projectInfo60$lea2.accountManager) === null || _vm$projectInfo60$lea3 === void 0 ? void 0 : _vm$projectInfo60$lea3.data
    }
  }), _c('div', [_c('b-button', {
    staticClass: "btn-icon rounded-circle",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        var _vm$projectInfo61, _vm$projectInfo61$lea;
        return _vm.showModal((_vm$projectInfo61 = _vm.projectInfo) === null || _vm$projectInfo61 === void 0 ? void 0 : (_vm$projectInfo61$lea = _vm$projectInfo61.lead) === null || _vm$projectInfo61$lea === void 0 ? void 0 : _vm$projectInfo61$lea.data);
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "Edit2Icon"
    }
  })], 1)], 1)], 1)] : [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")]), _c('div', [_c('b-button', {
    staticClass: "btn-icon rounded-circle",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        var _vm$projectInfo62, _vm$projectInfo62$lea;
        return _vm.showModal((_vm$projectInfo62 = _vm.projectInfo) === null || _vm$projectInfo62 === void 0 ? void 0 : (_vm$projectInfo62$lea = _vm$projectInfo62.lead) === null || _vm$projectInfo62$lea === void 0 ? void 0 : _vm$projectInfo62$lea.data);
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "Edit2Icon"
    }
  })], 1)], 1)], 1)]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Lead Assigned To: "), (_vm$projectInfo63 = _vm.projectInfo) !== null && _vm$projectInfo63 !== void 0 && (_vm$projectInfo63$lea = _vm$projectInfo63.lead) !== null && _vm$projectInfo63$lea !== void 0 && (_vm$projectInfo63$lea2 = _vm$projectInfo63$lea.data) !== null && _vm$projectInfo63$lea2 !== void 0 && _vm$projectInfo63$lea2.team ? [_c('div', _vm._l(((_vm$projectInfo64 = _vm.projectInfo) === null || _vm$projectInfo64 === void 0 ? void 0 : (_vm$projectInfo64$lea = _vm$projectInfo64.lead) === null || _vm$projectInfo64$lea === void 0 ? void 0 : (_vm$projectInfo64$lea2 = _vm$projectInfo64$lea.data) === null || _vm$projectInfo64$lea2 === void 0 ? void 0 : _vm$projectInfo64$lea2.team) || [], function (item, index) {
    return _c('span', {
      key: index
    }, _vm._l(item, function (user, userIndex) {
      return _c('userCard', {
        key: userIndex,
        attrs: {
          "user": user
        }
      });
    }), 1);
  }), 0)] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")])]], 2)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Project Estimated By: "), (_vm$projectInfo65 = _vm.projectInfo) !== null && _vm$projectInfo65 !== void 0 && _vm$projectInfo65.createdBy ? [_c('userCard', {
    attrs: {
      "user": (_vm$projectInfo66 = _vm.projectInfo) === null || _vm$projectInfo66 === void 0 ? void 0 : (_vm$projectInfo66$cre = _vm$projectInfo66.createdBy) === null || _vm$projectInfo66$cre === void 0 ? void 0 : _vm$projectInfo66$cre.data
    }
  })] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("N/A")])]], 2)])], 1)], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "8",
      "cols": "8"
    }
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.MILESTONE_CREATE, _vm.permissions) ? [[_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showProjectDetailMilestoneModal
    }
  }, [_vm._v(" " + _vm._s(!((_vm$projectInfo67 = _vm.projectInfo) !== null && _vm$projectInfo67 !== void 0 && _vm$projectInfo67.status) ? "Create Milestone" : "Create Extra Milestone") + " ")])]] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table table-custom-style striped",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        multipleColumns: true,
        initialSortBy: [{
          field: 'last_contact_date',
          type: 'desc'
        }]
      },
      "columns": _vm.columns
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$row2, _props$row4, _props$row5, _props$row6, _props$row7, _props$row8, _props$row9, _props$column2, _props$row10, _props$row11, _props$row12, _props$row13, _props$row14, _props$row15, _props$row16, _props$row17, _props$row18, _props$row19, _props$row20, _props$row21, _props$column3, _props$row22, _props$row23, _props$column4, _props$row24, _props$row25, _props$row26, _props$column5, _props$column6;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_milestone_info' ? [props !== null && props !== void 0 && (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.title ? _c('div', {
          staticClass: "mt-1"
        }, [(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.status) == 'paid' ? _c('b-link', {
          on: {
            "click": function click($event) {
              var _props$row3;
              return _vm.onTaskBoardPage(props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.id);
            }
          }
        }, [_c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.title))]), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatMilestoneType(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : _props$row5.is_extra)))])], 1) : _c('span', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.title) + " "), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatMilestoneType(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.is_extra)))])], 1)], 1) : _vm._e(), props !== null && props !== void 0 && (_props$row8 = props.row) !== null && _props$row8 !== void 0 && _props$row8.payment_type ? _c('div', {
          staticClass: "mt-1 mb-1"
        }, [_vm._v(" Payment Type: "), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatType(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.payment_type)))])], 1) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_amount' ? [props !== null && props !== void 0 && (_props$row10 = props.row) !== null && _props$row10 !== void 0 && _props$row10.amount ? _c('div', {
          staticClass: "table-cell-margin"
        }, [_c('span', [_vm._v("Amount: "), _c('FormatCurrency', {
          attrs: {
            "currency": props === null || props === void 0 ? void 0 : (_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : _props$row11.currency,
            "amount": props === null || props === void 0 ? void 0 : (_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : _props$row12.amount
          }
        })], 1)]) : _vm._e(), props !== null && props !== void 0 && (_props$row13 = props.row) !== null && _props$row13 !== void 0 && _props$row13.vat_amount ? _c('div', {
          staticClass: "table-cell-margin"
        }, [_c('span', [_vm._v("VAT: "), _c('FormatCurrency', {
          attrs: {
            "currency": props === null || props === void 0 ? void 0 : (_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : _props$row14.currency,
            "amount": props === null || props === void 0 ? void 0 : (_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : _props$row15.vat_amount
          }
        })], 1)]) : _vm._e(), props !== null && props !== void 0 && (_props$row16 = props.row) !== null && _props$row16 !== void 0 && _props$row16.tax_amount ? _c('div', {
          staticClass: "table-cell-margin"
        }, [_c('span', [_vm._v("TAX: "), _c('FormatCurrency', {
          attrs: {
            "currency": props === null || props === void 0 ? void 0 : (_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : _props$row17.currency,
            "amount": props === null || props === void 0 ? void 0 : (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : _props$row18.tax_amount
          }
        })], 1)]) : _vm._e(), props !== null && props !== void 0 && (_props$row19 = props.row) !== null && _props$row19 !== void 0 && _props$row19.grand_amount ? _c('div', {
          staticClass: "table-cell-margin"
        }, [_c('span', [_vm._v("Total Amount: "), _c('FormatCurrency', {
          attrs: {
            "currency": props === null || props === void 0 ? void 0 : (_props$row20 = props.row) === null || _props$row20 === void 0 ? void 0 : _props$row20.currency,
            "amount": props === null || props === void 0 ? void 0 : (_props$row21 = props.row) === null || _props$row21 === void 0 ? void 0 : _props$row21.grand_amount
          }
        })], 1)]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_currency' ? [_c('FormatCurrency', {
          attrs: {
            "type": 'currency',
            "currency": props === null || props === void 0 ? void 0 : (_props$row22 = props.row) === null || _props$row22 === void 0 ? void 0 : _props$row22.currency,
            "amount": props === null || props === void 0 ? void 0 : (_props$row23 = props.row) === null || _props$row23 === void 0 ? void 0 : _props$row23.total_amount
          }
        })] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_status' ? [(props === null || props === void 0 ? void 0 : (_props$row24 = props.row) === null || _props$row24 === void 0 ? void 0 : _props$row24.status) == 'paid' ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-success"
          }
        }, [_vm._v("Paid")])] : (props === null || props === void 0 ? void 0 : (_props$row25 = props.row) === null || _props$row25 === void 0 ? void 0 : _props$row25.status) == 'due' ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-danger"
          }
        }, [_vm._v("Due")])] : (props === null || props === void 0 ? void 0 : (_props$row26 = props.row) === null || _props$row26 === void 0 ? void 0 : _props$row26.status) == 'forward' ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-info"
          }
        }, [_vm._v("Forwarded")])] : _vm._e()] : _vm._e(), _vm.$permissionAbility(_vm.MILESTONE_EDIT, _vm.permissions) || _vm.$permissionAbility(_vm.permissions) || _vm.$permissionAbility(_vm.MILESTONE_DELETE, _vm.permissions) ? void 0 : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'action' ? _c('span', [_vm.$permissionAbility(_vm.MILESTONE_EDIT, _vm.permissions) || _vm.$permissionAbility(_vm.PROJECT_APPROVED_EDIT, _vm.permissions) || _vm.$permissionAbility(_vm.MILESTONE_DELETE, _vm.permissions) ? [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.MILESTONE_EDIT, _vm.permissions) || _vm.$permissionAbility(_vm.PROJECT_APPROVED_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.MILESTONE_DELETE, _vm.permissions) || _vm.$permissionAbility(_vm.PROJECT_APPROVED_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              var _props$row27;
              return _vm.onDelete(props === null || props === void 0 ? void 0 : (_props$row27 = props.row) === null || _props$row27 === void 0 ? void 0 : _props$row27.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)] : _vm._e()], 2)] : [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-danger"
          }
        }, [_vm._v("Not Permitted")])]], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props === null || props === void 0 ? void 0 : (_props$column6 = props.column) === null || _props$column6 === void 0 ? void 0 : _props$column6.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props === null || props === void 0 ? void 0 : props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-project-details-form",
      "centered": "",
      "title": "Edit Project Details",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "xl"
    },
    on: {
      "hidden": _vm.hideProjectDetailsModal
    }
  }, [_c('validation-observer', {
    ref: "projectDetailsValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.projectDetailsValidationForm($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Title (Lead Title) *",
      "label-for": "title"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "project title (lead title)",
      "vid": "title",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "title",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Project Title (Lead Title) "
          },
          model: {
            value: _vm.title,
            callback: function callback($$v) {
              _vm.title = $$v;
            },
            expression: "title"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Type *",
      "label-for": "projectType"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "project type",
      "vid": "project_type",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "projectType",
            "placeholder": "Choose Project Type",
            "options": _vm.projectTypeConstants,
            "reduce": function reduce(country) {
              return country.value;
            },
            "label": "name"
          },
          model: {
            value: _vm.projectType,
            callback: function callback($$v) {
              _vm.projectType = $$v;
            },
            expression: "projectType"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Type *",
      "label-for": "paymentType"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "payment type",
      "vid": "payment_type",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "paymentType",
            "placeholder": "Choose Payment Type",
            "options": _vm.paymentTypeConstants,
            "reduce": function reduce(country) {
              return country.value;
            },
            "label": "name"
          },
          model: {
            value: _vm.paymentType,
            callback: function callback($$v) {
              _vm.paymentType = $$v;
            },
            expression: "paymentType"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Currency *",
      "label-for": "currency"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "Currency",
      "vid": "currency",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "currency",
            "placeholder": "Choose a Currency",
            "options": _vm.currencyOption,
            "reduce": function reduce(option) {
              return option === null || option === void 0 ? void 0 : option.currency;
            },
            "label": "currency",
            "disabled": _vm.isApprovedProjectEdit
          },
          model: {
            value: _vm.selectCurrency,
            callback: function callback($$v) {
              _vm.selectCurrency = $$v;
            },
            expression: "selectCurrency"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Final Amount *",
      "label-for": "amount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "amount",
      "vid": "amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "amount",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Final Amount",
            "disabled": _vm.isApprovedProjectEdit
          },
          on: {
            "input": _vm.calculateProjectInfo
          },
          model: {
            value: _vm.amount,
            callback: function callback($$v) {
              _vm.amount = $$v;
            },
            expression: "amount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "VAT *",
      "label-for": "vatAmount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "vat amount",
      "vid": "vat_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "vatAmount",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter VAT Amount",
            "disabled": _vm.isApprovedProjectEdit
          },
          on: {
            "input": _vm.calculateProjectInfo
          },
          model: {
            value: _vm.vatAmount,
            callback: function callback($$v) {
              _vm.vatAmount = $$v;
            },
            expression: "vatAmount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "TAX *",
      "label-for": "taxAmount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tax amount",
      "vid": "tax_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "taxAmount",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter TAX Amount",
            "disabled": _vm.isApprovedProjectEdit
          },
          on: {
            "input": _vm.calculateProjectInfo
          },
          model: {
            value: _vm.taxAmount,
            callback: function callback($$v) {
              _vm.taxAmount = $$v;
            },
            expression: "taxAmount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Grand Total *",
      "label-for": "grandAmount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "grand total",
      "vid": "grand_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "grandAmount",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Grand Total",
            "disabled": ""
          },
          model: {
            value: _vm.grandAmount,
            callback: function callback($$v) {
              _vm.grandAmount = $$v;
            },
            expression: "grandAmount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Time Duration (Months) *",
      "label-for": "timeDuration"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "time duration",
      "vid": "time_duration",
      "rules": "required|numeric|max_value:12|min_value:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "timeDuration",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Time Duration",
            "disabled": _vm.isApprovedProjectEdit
          },
          model: {
            value: _vm.timeDuration,
            callback: function callback($$v) {
              _vm.timeDuration = $$v;
            },
            expression: "timeDuration"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Milestone *",
      "label-for": "milestone"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "milestone",
      "vid": "milestone",
      "rules": "required|numeric|max_value:12|min_value:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Number of Milestones",
            "disabled": _vm.isApprovedProjectEdit
          },
          model: {
            value: _vm.milestones,
            callback: function callback($$v) {
              _vm.milestones = $$v;
            },
            expression: "milestones"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "proposal",
      "label-for": "proposal"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "proposal",
      "rules": 'size:8048|ext:jpg,jpeg,png,pdf,csv,xlsx,txt,docx',
      "vid": "proposal"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var errors = _ref11.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": "proposal",
            "state": errors.length ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          model: {
            value: _vm.proposal,
            callback: function callback($$v) {
              _vm.proposal = $$v;
            },
            expression: "proposal"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), (_vm$projectInfo68 = _vm.projectInfo) !== null && _vm$projectInfo68 !== void 0 && _vm$projectInfo68.proposal_url ? [_c('b-link', {
    attrs: {
      "href": (_vm$projectInfo69 = _vm.projectInfo) === null || _vm$projectInfo69 === void 0 ? void 0 : _vm$projectInfo69.proposal_url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.projectInfo.proposal_filename) + " ")])] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "md": "8",
      "lg": "8",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Remarks",
      "label-for": "Remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Remarks",
      "vid": "remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var errors = _ref12.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _vm.isProjectDetailsFormLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-project-milestone-form",
      "centered": "",
      "title": _vm.modalType == 'edit' ? 'Edit Milestone' : 'Add Milestone',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hideProjectMileStoneModal
    }
  }, [_c('validation-observer', {
    ref: "projectMilestoneValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.projectMilestoneValidationForm($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Milestone Title",
      "label-for": "post-fix"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "post_fix",
      "vid": "post_fix"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref13) {
        var errors = _ref13.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "post_fix",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Milestone Title"
          },
          model: {
            value: _vm.postFix,
            callback: function callback($$v) {
              _vm.postFix = $$v;
            },
            expression: "postFix"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Amount ",
      "label-for": "amount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "amount",
      "vid": "amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref14) {
        var errors = _ref14.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "amount",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Final Amount"
          },
          on: {
            "input": _vm.calculateMilestoneInfo
          },
          model: {
            value: _vm.amountMilestone,
            callback: function callback($$v) {
              _vm.amountMilestone = $$v;
            },
            expression: "amountMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "VAT ",
      "label-for": "vatAmount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "vat amount",
      "vid": "vat_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref15) {
        var errors = _ref15.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter VAT Amount"
          },
          on: {
            "input": _vm.calculateMilestoneInfo
          },
          model: {
            value: _vm.vatMilestone,
            callback: function callback($$v) {
              _vm.vatMilestone = $$v;
            },
            expression: "vatMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "TAX ",
      "label-for": "taxAmount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tax amount",
      "vid": "tax_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref16) {
        var errors = _ref16.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter TAX Amount"
          },
          on: {
            "input": _vm.calculateMilestoneInfo
          },
          model: {
            value: _vm.taxMilestone,
            callback: function callback($$v) {
              _vm.taxMilestone = $$v;
            },
            expression: "taxMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Total ",
      "label-for": "grandTotal"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "total amount",
      "vid": "grand_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref17) {
        var errors = _ref17.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Total Amount",
            "disabled": ""
          },
          model: {
            value: _vm.totalMilestone,
            callback: function callback($$v) {
              _vm.totalMilestone = $$v;
            },
            expression: "totalMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Payment Type ",
      "label-for": "paymentType"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "payment type",
      "vid": "payment_type",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref18) {
        var errors = _ref18.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "paymentType",
            "placeholder": "Choose Payment Type",
            "options": _vm.paymentTypeConstants,
            "label": "name",
            "reduce": function reduce(country) {
              return country.value;
            }
          },
          model: {
            value: _vm.paymentTypeMilestone,
            callback: function callback($$v) {
              _vm.paymentTypeMilestone = $$v;
            },
            expression: "paymentTypeMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Milestone Deadline",
      "label-for": "date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "deadline",
      "vid": "date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref19) {
        var errors = _ref19.errors;
        return [_c('b-form-datepicker', {
          staticClass: "custom-font",
          attrs: {
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Milestone Deadline",
            "locale": "en-US",
            "place": ""
          },
          model: {
            value: _vm.deadlineMilestone,
            callback: function callback($$v) {
              _vm.deadlineMilestone = $$v;
            },
            expression: "deadlineMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Deadline ",
      "label-for": "date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "payment deadline",
      "vid": "payment_deadline"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref20) {
        var errors = _ref20.errors;
        return [_c('b-form-datepicker', {
          staticClass: "custom-font",
          attrs: {
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Payment Deadline",
            "locale": "en-US",
            "place": ""
          },
          model: {
            value: _vm.paymentDeadlineMilestone,
            callback: function callback($$v) {
              _vm.paymentDeadlineMilestone = $$v;
            },
            expression: "paymentDeadlineMilestone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)]], 2), _vm.isProjectMilestoneFormLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "md": "4"
    }
  }, [_c('b-card', [_c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, [_c('b-card', {
    attrs: {
      "title": "Project Activity Log"
    }
  }, [_c('app-timeline', [_vm._l(_vm.projectActivityLogs, function (item) {
    var _item$properties, _item$properties$attr, _item$properties2, _item$properties2$old, _item$properties3, _item$properties3$att, _item$properties3$att2, _item$properties4, _item$properties4$use, _item$properties5, _item$properties5$att, _item$properties5$att2, _item$properties6, _item$properties6$att, _item$properties6$att2, _item$properties7, _item$properties7$old, _item$properties8, _item$properties8$old, _item$properties9, _item$properties9$old, _item$properties10, _item$properties10$ol, _item$properties11, _item$properties11$ol, _item$properties12, _item$properties12$ol, _item$properties13, _item$properties13$ol, _item$properties14, _item$properties14$ol, _item$properties15, _item$properties15$ol, _item$properties16, _item$properties16$ol, _item$properties17, _item$properties17$ol, _item$properties18, _item$properties18$ol, _item$properties19, _item$properties19$ol, _item$properties20, _item$properties20$ol, _item$properties21, _item$properties21$ol, _item$properties22, _item$properties22$ol, _item$properties23, _item$properties23$ol, _item$properties24, _item$properties24$at, _item$properties25, _item$properties25$ol, _item$properties26, _item$properties26$at, _item$properties27, _item$properties27$at, _item$properties28, _item$properties28$at, _item$properties29, _item$properties29$ol, _item$properties30, _item$properties30$at, _item$properties31, _item$properties31$at, _item$properties32, _item$properties32$at, _item$properties33, _item$properties33$ol, _item$properties34, _item$properties34$at, _item$properties35, _item$properties35$at, _item$properties36, _item$properties36$at, _item$properties37, _item$properties37$ol, _item$properties38, _item$properties38$at, _item$properties39, _item$properties39$at, _item$properties40, _item$properties40$at, _item$properties41, _item$properties41$ol, _item$properties42, _item$properties42$at, _item$properties43, _item$properties43$at, _item$properties44, _item$properties44$at, _item$properties45, _item$properties45$ol, _item$properties46, _item$properties46$at, _item$properties47, _item$properties47$at, _item$properties48, _item$properties48$at, _item$properties49, _item$properties49$ol, _item$properties50, _item$properties50$at, _item$properties51, _item$properties51$at, _item$properties52, _item$properties52$at, _item$properties53, _item$properties53$ol, _item$properties54, _item$properties54$at, _item$properties55, _item$properties55$at, _item$properties56, _item$properties56$at, _item$properties57, _item$properties57$ol, _item$properties58, _item$properties58$at, _item$properties59, _item$properties59$at, _item$properties60, _item$properties60$at, _item$properties61, _item$properties61$ol, _item$properties62, _item$properties62$at, _item$properties63, _item$properties63$at, _item$properties64, _item$properties64$at, _item$properties65, _item$properties65$ol, _item$properties66, _item$properties66$at, _item$properties67, _item$properties67$at, _item$properties68, _item$properties68$at, _item$properties69, _item$properties69$ol, _item$properties70, _item$properties70$at, _item$properties71, _item$properties71$at, _item$properties72, _item$properties72$at, _item$properties73, _item$properties73$ol, _item$properties74, _item$properties74$at, _item$properties75, _item$properties75$at, _item$properties76, _item$properties76$at, _item$properties77, _item$properties77$ol, _item$properties78, _item$properties78$at, _item$properties79, _item$properties79$at, _item$properties80, _item$properties80$at, _item$properties81, _item$properties81$ol, _item$properties82, _item$properties82$at, _item$properties83, _item$properties83$at, _item$properties84, _item$properties84$at, _item$properties85, _item$properties85$ol, _item$properties86, _item$properties86$at, _item$properties87, _item$properties87$at, _item$properties88, _item$properties88$at, _item$properties89, _item$properties89$ol, _item$properties90, _item$properties90$at, _item$properties91, _item$properties91$at, _item$properties92, _item$properties92$at, _item$properties93, _item$properties93$at, _item$properties93$at2, _item$properties94, _item$properties94$at, _item$properties95, _item$properties95$at, _item$properties95$at2, _item$properties96, _item$properties96$ol, _item$properties97, _item$properties97$ol, _item$properties98, _item$properties98$ol, _item$properties99, _item$properties99$ol, _item$properties100, _item$properties100$o, _item$properties101, _item$properties101$o, _item$properties102, _item$properties102$o, _item$properties103, _item$properties103$a, _item$properties104, _item$properties104$o, _item$properties105, _item$properties105$a, _item$properties106, _item$properties106$a, _item$properties107, _item$properties107$a, _item$properties108, _item$properties108$o, _item$properties109, _item$properties109$a, _item$properties110, _item$properties110$a, _item$properties111, _item$properties111$a, _item$properties112, _item$properties112$o, _item$properties113, _item$properties113$a, _item$properties114, _item$properties114$a, _item$properties115, _item$properties115$a, _item$properties116, _item$properties116$o, _item$properties117, _item$properties117$a, _item$properties118, _item$properties118$a, _item$properties119, _item$properties119$a, _item$properties120, _item$properties120$o, _item$properties121, _item$properties121$a, _item$properties122, _item$properties122$a, _item$properties123, _item$properties123$a, _item$properties124, _item$properties124$o, _item$properties125, _item$properties125$a, _item$properties126, _item$properties126$a, _item$properties127, _item$properties127$a, _item$properties128, _item$properties128$o, _item$properties129, _item$properties129$a, _item$properties130, _item$properties130$a;
    return [(item === null || item === void 0 ? void 0 : item.log_name) == 'projects' && (item === null || item === void 0 ? void 0 : item.description) == 'updated' && (item === null || item === void 0 ? void 0 : (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : (_item$properties$attr = _item$properties.attributes) === null || _item$properties$attr === void 0 ? void 0 : _item$properties$attr.status) != (item === null || item === void 0 ? void 0 : (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : (_item$properties2$old = _item$properties2.old) === null || _item$properties2$old === void 0 ? void 0 : _item$properties2$old.status) ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "primary",
        "title": "Project Approved by ".concat(item === null || item === void 0 ? void 0 : (_item$properties3 = item.properties) === null || _item$properties3 === void 0 ? void 0 : (_item$properties3$att = _item$properties3.attributes) === null || _item$properties3$att === void 0 ? void 0 : (_item$properties3$att2 = _item$properties3$att.updatedBy) === null || _item$properties3$att2 === void 0 ? void 0 : _item$properties3$att2.name),
        "subtitle": _vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at),
        "time": _vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)
      }
    })] : _vm._e(), (item === null || item === void 0 ? void 0 : item.log_name) == 'projects' && (item === null || item === void 0 ? void 0 : item.event) == 'updated' && (item === null || item === void 0 ? void 0 : item.description) == 'Lead #' + _vm.leadId + ' updated' ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "primary",
        "title": "Key Account Manager Updated by ".concat(item === null || item === void 0 ? void 0 : (_item$properties4 = item.properties) === null || _item$properties4 === void 0 ? void 0 : (_item$properties4$use = _item$properties4.user) === null || _item$properties4$use === void 0 ? void 0 : _item$properties4$use.name),
        "subtitle": _vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at),
        "time": _vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)
      }
    })] : (item === null || item === void 0 ? void 0 : item.log_name) == 'projects' && (item === null || item === void 0 ? void 0 : item.description) == 'created' ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "primary",
        "title": "Project Information Created by ".concat(item === null || item === void 0 ? void 0 : (_item$properties5 = item.properties) === null || _item$properties5 === void 0 ? void 0 : (_item$properties5$att = _item$properties5.attributes) === null || _item$properties5$att === void 0 ? void 0 : (_item$properties5$att2 = _item$properties5$att.createdBy) === null || _item$properties5$att2 === void 0 ? void 0 : _item$properties5$att2.name),
        "subtitle": _vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at),
        "time": _vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)
      }
    })] : (item === null || item === void 0 ? void 0 : item.log_name) == 'projects' && (item === null || item === void 0 ? void 0 : item.description) == 'updated' ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "primary"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', [_vm._v(" " + _vm._s("Project Information updated by ".concat(item === null || item === void 0 ? void 0 : (_item$properties6 = item.properties) === null || _item$properties6 === void 0 ? void 0 : (_item$properties6$att = _item$properties6.attributes) === null || _item$properties6$att === void 0 ? void 0 : (_item$properties6$att2 = _item$properties6$att.updatedBy) === null || _item$properties6$att2 === void 0 ? void 0 : _item$properties6$att2.name)) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)))]), _c('span', {
      staticClass: "align-bottom"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at)))]), _c('br'), _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: "project-change-list-".concat(item === null || item === void 0 ? void 0 : item.id),
        expression: "`project-change-list-${item?.id}`"
      }, {
        name: "ripple",
        rawName: "v-ripple.400",
        value: 'rgba(113, 102, 240, 0.15)',
        expression: "'rgba(113, 102, 240, 0.15)'",
        modifiers: {
          "400": true
        }
      }],
      staticClass: "mt-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      }
    }, [_vm._v(" Show Changes ")]), _c('b-collapse', {
      attrs: {
        "id": "project-change-list-".concat(item === null || item === void 0 ? void 0 : item.id)
      }
    }, [_c('b-row', {
      staticClass: "custom-font"
    }, [_c('b-col', {
      staticClass: "pr-1",
      attrs: {
        "cols": "6"
      }
    }, [_c('b-list-group', {
      staticClass: "mt-1",
      attrs: {
        "flush": ""
      }
    }, [_c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Previous")])])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Title:")]), _vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties7 = item.properties) === null || _item$properties7 === void 0 ? void 0 : (_item$properties7$old = _item$properties7.old) === null || _item$properties7$old === void 0 ? void 0 : _item$properties7$old.title)))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties8 = item.properties) === null || _item$properties8 === void 0 ? void 0 : (_item$properties8$old = _item$properties8.old) === null || _item$properties8$old === void 0 ? void 0 : _item$properties8$old.project_type)))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Payment:")]), _vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties9 = item.properties) === null || _item$properties9 === void 0 ? void 0 : (_item$properties9$old = _item$properties9.old) === null || _item$properties9$old === void 0 ? void 0 : _item$properties9$old.payment_type)))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Duration:")]), _vm._v(" " + _vm._s("".concat(item === null || item === void 0 ? void 0 : (_item$properties10 = item.properties) === null || _item$properties10 === void 0 ? void 0 : (_item$properties10$ol = _item$properties10.old) === null || _item$properties10$ol === void 0 ? void 0 : _item$properties10$ol.time_duration, " Months")))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Amount: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties11 = item.properties) === null || _item$properties11 === void 0 ? void 0 : (_item$properties11$ol = _item$properties11.old) === null || _item$properties11$ol === void 0 ? void 0 : _item$properties11$ol.amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Extra: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties12 = item.properties) === null || _item$properties12 === void 0 ? void 0 : (_item$properties12$ol = _item$properties12.old) === null || _item$properties12$ol === void 0 ? void 0 : _item$properties12$ol.extra_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Total: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties13 = item.properties) === null || _item$properties13 === void 0 ? void 0 : (_item$properties13$ol = _item$properties13.old) === null || _item$properties13$ol === void 0 ? void 0 : _item$properties13$ol.total_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("VAT: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties14 = item.properties) === null || _item$properties14 === void 0 ? void 0 : (_item$properties14$ol = _item$properties14.old) === null || _item$properties14$ol === void 0 ? void 0 : _item$properties14$ol.vat_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Extra: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties15 = item.properties) === null || _item$properties15 === void 0 ? void 0 : (_item$properties15$ol = _item$properties15.old) === null || _item$properties15$ol === void 0 ? void 0 : _item$properties15$ol.extra_vat_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("VAT Total: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties16 = item.properties) === null || _item$properties16 === void 0 ? void 0 : (_item$properties16$ol = _item$properties16.old) === null || _item$properties16$ol === void 0 ? void 0 : _item$properties16$ol.total_vat_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("TAX: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties17 = item.properties) === null || _item$properties17 === void 0 ? void 0 : (_item$properties17$ol = _item$properties17.old) === null || _item$properties17$ol === void 0 ? void 0 : _item$properties17$ol.tax_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Extra: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties18 = item.properties) === null || _item$properties18 === void 0 ? void 0 : (_item$properties18$ol = _item$properties18.old) === null || _item$properties18$ol === void 0 ? void 0 : _item$properties18$ol.extra_tax_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("TAX Total: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties19 = item.properties) === null || _item$properties19 === void 0 ? void 0 : (_item$properties19$ol = _item$properties19.old) === null || _item$properties19$ol === void 0 ? void 0 : _item$properties19$ol.total_tax_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Grand Total: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties20 = item.properties) === null || _item$properties20 === void 0 ? void 0 : (_item$properties20$ol = _item$properties20.old) === null || _item$properties20$ol === void 0 ? void 0 : _item$properties20$ol.grand_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Milestones:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties21 = item.properties) === null || _item$properties21 === void 0 ? void 0 : (_item$properties21$ol = _item$properties21.old) === null || _item$properties21$ol === void 0 ? void 0 : _item$properties21$ol.milestone))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Extra: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties22 = item.properties) === null || _item$properties22 === void 0 ? void 0 : (_item$properties22$ol = _item$properties22.old) === null || _item$properties22$ol === void 0 ? void 0 : _item$properties22$ol.extra_milestone))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Total: ")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties23 = item.properties) === null || _item$properties23 === void 0 ? void 0 : (_item$properties23$ol = _item$properties23.old) === null || _item$properties23$ol === void 0 ? void 0 : _item$properties23$ol.total_milestone))])])], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('b-list-group', {
      staticClass: "mt-1",
      attrs: {
        "flush": ""
      }
    }, [_c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Updated")])])]), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Title: ")]), (item === null || item === void 0 ? void 0 : (_item$properties24 = item.properties) === null || _item$properties24 === void 0 ? void 0 : (_item$properties24$at = _item$properties24.attributes) === null || _item$properties24$at === void 0 ? void 0 : _item$properties24$at.title) !== (item === null || item === void 0 ? void 0 : (_item$properties25 = item.properties) === null || _item$properties25 === void 0 ? void 0 : (_item$properties25$ol = _item$properties25.old) === null || _item$properties25$ol === void 0 ? void 0 : _item$properties25$ol.title) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties26 = item.properties) === null || _item$properties26 === void 0 ? void 0 : (_item$properties26$at = _item$properties26.attributes) === null || _item$properties26$at === void 0 ? void 0 : _item$properties26$at.title)))])] : [_c('span', [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties27 = item.properties) === null || _item$properties27 === void 0 ? void 0 : (_item$properties27$at = _item$properties27.attributes) === null || _item$properties27$at === void 0 ? void 0 : _item$properties27$at.title)) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v(" Type: ")]), (item === null || item === void 0 ? void 0 : (_item$properties28 = item.properties) === null || _item$properties28 === void 0 ? void 0 : (_item$properties28$at = _item$properties28.attributes) === null || _item$properties28$at === void 0 ? void 0 : _item$properties28$at.project_type) !== (item === null || item === void 0 ? void 0 : (_item$properties29 = item.properties) === null || _item$properties29 === void 0 ? void 0 : (_item$properties29$ol = _item$properties29.old) === null || _item$properties29$ol === void 0 ? void 0 : _item$properties29$ol.project_type) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties30 = item.properties) === null || _item$properties30 === void 0 ? void 0 : (_item$properties30$at = _item$properties30.attributes) === null || _item$properties30$at === void 0 ? void 0 : _item$properties30$at.project_type)))])] : [_c('span', [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties31 = item.properties) === null || _item$properties31 === void 0 ? void 0 : (_item$properties31$at = _item$properties31.attributes) === null || _item$properties31$at === void 0 ? void 0 : _item$properties31$at.project_type)) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Payment: ")]), (item === null || item === void 0 ? void 0 : (_item$properties32 = item.properties) === null || _item$properties32 === void 0 ? void 0 : (_item$properties32$at = _item$properties32.attributes) === null || _item$properties32$at === void 0 ? void 0 : _item$properties32$at.payment_type) !== (item === null || item === void 0 ? void 0 : (_item$properties33 = item.properties) === null || _item$properties33 === void 0 ? void 0 : (_item$properties33$ol = _item$properties33.old) === null || _item$properties33$ol === void 0 ? void 0 : _item$properties33$ol.payment_type) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties34 = item.properties) === null || _item$properties34 === void 0 ? void 0 : (_item$properties34$at = _item$properties34.attributes) === null || _item$properties34$at === void 0 ? void 0 : _item$properties34$at.payment_type)))])] : [_c('span', [_vm._v(_vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties35 = item.properties) === null || _item$properties35 === void 0 ? void 0 : (_item$properties35$at = _item$properties35.attributes) === null || _item$properties35$at === void 0 ? void 0 : _item$properties35$at.payment_type)))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v(" Duration: ")]), (item === null || item === void 0 ? void 0 : (_item$properties36 = item.properties) === null || _item$properties36 === void 0 ? void 0 : (_item$properties36$at = _item$properties36.attributes) === null || _item$properties36$at === void 0 ? void 0 : _item$properties36$at.time_duration) !== (item === null || item === void 0 ? void 0 : (_item$properties37 = item.properties) === null || _item$properties37 === void 0 ? void 0 : (_item$properties37$ol = _item$properties37.old) === null || _item$properties37$ol === void 0 ? void 0 : _item$properties37$ol.time_duration) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s("".concat(item === null || item === void 0 ? void 0 : (_item$properties38 = item.properties) === null || _item$properties38 === void 0 ? void 0 : (_item$properties38$at = _item$properties38.attributes) === null || _item$properties38$at === void 0 ? void 0 : _item$properties38$at.time_duration, " Months")))])] : [_c('span', [_vm._v(" " + _vm._s("".concat(item === null || item === void 0 ? void 0 : (_item$properties39 = item.properties) === null || _item$properties39 === void 0 ? void 0 : (_item$properties39$at = _item$properties39.attributes) === null || _item$properties39$at === void 0 ? void 0 : _item$properties39$at.time_duration, " Months")))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties40 = item.properties) === null || _item$properties40 === void 0 ? void 0 : (_item$properties40$at = _item$properties40.attributes) === null || _item$properties40$at === void 0 ? void 0 : _item$properties40$at.amount) !== (item === null || item === void 0 ? void 0 : (_item$properties41 = item.properties) === null || _item$properties41 === void 0 ? void 0 : (_item$properties41$ol = _item$properties41.old) === null || _item$properties41$ol === void 0 ? void 0 : _item$properties41$ol.amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties42 = item.properties) === null || _item$properties42 === void 0 ? void 0 : (_item$properties42$at = _item$properties42.attributes) === null || _item$properties42$at === void 0 ? void 0 : _item$properties42$at.amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties43 = item.properties) === null || _item$properties43 === void 0 ? void 0 : (_item$properties43$at = _item$properties43.attributes) === null || _item$properties43$at === void 0 ? void 0 : _item$properties43$at.amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Extra: ")]), (item === null || item === void 0 ? void 0 : (_item$properties44 = item.properties) === null || _item$properties44 === void 0 ? void 0 : (_item$properties44$at = _item$properties44.attributes) === null || _item$properties44$at === void 0 ? void 0 : _item$properties44$at.extra_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties45 = item.properties) === null || _item$properties45 === void 0 ? void 0 : (_item$properties45$ol = _item$properties45.old) === null || _item$properties45$ol === void 0 ? void 0 : _item$properties45$ol.extra_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties46 = item.properties) === null || _item$properties46 === void 0 ? void 0 : (_item$properties46$at = _item$properties46.attributes) === null || _item$properties46$at === void 0 ? void 0 : _item$properties46$at.extra_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties47 = item.properties) === null || _item$properties47 === void 0 ? void 0 : (_item$properties47$at = _item$properties47.attributes) === null || _item$properties47$at === void 0 ? void 0 : _item$properties47$at.extra_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Total: ")]), (item === null || item === void 0 ? void 0 : (_item$properties48 = item.properties) === null || _item$properties48 === void 0 ? void 0 : (_item$properties48$at = _item$properties48.attributes) === null || _item$properties48$at === void 0 ? void 0 : _item$properties48$at.total_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties49 = item.properties) === null || _item$properties49 === void 0 ? void 0 : (_item$properties49$ol = _item$properties49.old) === null || _item$properties49$ol === void 0 ? void 0 : _item$properties49$ol.total_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties50 = item.properties) === null || _item$properties50 === void 0 ? void 0 : (_item$properties50$at = _item$properties50.attributes) === null || _item$properties50$at === void 0 ? void 0 : _item$properties50$at.total_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties51 = item.properties) === null || _item$properties51 === void 0 ? void 0 : (_item$properties51$at = _item$properties51.attributes) === null || _item$properties51$at === void 0 ? void 0 : _item$properties51$at.total_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("VAT: ")]), (item === null || item === void 0 ? void 0 : (_item$properties52 = item.properties) === null || _item$properties52 === void 0 ? void 0 : (_item$properties52$at = _item$properties52.attributes) === null || _item$properties52$at === void 0 ? void 0 : _item$properties52$at.vat_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties53 = item.properties) === null || _item$properties53 === void 0 ? void 0 : (_item$properties53$ol = _item$properties53.old) === null || _item$properties53$ol === void 0 ? void 0 : _item$properties53$ol.vat_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties54 = item.properties) === null || _item$properties54 === void 0 ? void 0 : (_item$properties54$at = _item$properties54.attributes) === null || _item$properties54$at === void 0 ? void 0 : _item$properties54$at.vat_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties55 = item.properties) === null || _item$properties55 === void 0 ? void 0 : (_item$properties55$at = _item$properties55.attributes) === null || _item$properties55$at === void 0 ? void 0 : _item$properties55$at.vat_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Extra: ")]), (item === null || item === void 0 ? void 0 : (_item$properties56 = item.properties) === null || _item$properties56 === void 0 ? void 0 : (_item$properties56$at = _item$properties56.attributes) === null || _item$properties56$at === void 0 ? void 0 : _item$properties56$at.extra_vat_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties57 = item.properties) === null || _item$properties57 === void 0 ? void 0 : (_item$properties57$ol = _item$properties57.old) === null || _item$properties57$ol === void 0 ? void 0 : _item$properties57$ol.extra_vat_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties58 = item.properties) === null || _item$properties58 === void 0 ? void 0 : (_item$properties58$at = _item$properties58.attributes) === null || _item$properties58$at === void 0 ? void 0 : _item$properties58$at.extra_vat_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties59 = item.properties) === null || _item$properties59 === void 0 ? void 0 : (_item$properties59$at = _item$properties59.attributes) === null || _item$properties59$at === void 0 ? void 0 : _item$properties59$at.extra_vat_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("VAT Total: ")]), (item === null || item === void 0 ? void 0 : (_item$properties60 = item.properties) === null || _item$properties60 === void 0 ? void 0 : (_item$properties60$at = _item$properties60.attributes) === null || _item$properties60$at === void 0 ? void 0 : _item$properties60$at.total_vat_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties61 = item.properties) === null || _item$properties61 === void 0 ? void 0 : (_item$properties61$ol = _item$properties61.old) === null || _item$properties61$ol === void 0 ? void 0 : _item$properties61$ol.total_vat_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties62 = item.properties) === null || _item$properties62 === void 0 ? void 0 : (_item$properties62$at = _item$properties62.attributes) === null || _item$properties62$at === void 0 ? void 0 : _item$properties62$at.total_vat_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties63 = item.properties) === null || _item$properties63 === void 0 ? void 0 : (_item$properties63$at = _item$properties63.attributes) === null || _item$properties63$at === void 0 ? void 0 : _item$properties63$at.total_vat_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("TAX:")]), (item === null || item === void 0 ? void 0 : (_item$properties64 = item.properties) === null || _item$properties64 === void 0 ? void 0 : (_item$properties64$at = _item$properties64.attributes) === null || _item$properties64$at === void 0 ? void 0 : _item$properties64$at.tax_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties65 = item.properties) === null || _item$properties65 === void 0 ? void 0 : (_item$properties65$ol = _item$properties65.old) === null || _item$properties65$ol === void 0 ? void 0 : _item$properties65$ol.tax_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties66 = item.properties) === null || _item$properties66 === void 0 ? void 0 : (_item$properties66$at = _item$properties66.attributes) === null || _item$properties66$at === void 0 ? void 0 : _item$properties66$at.tax_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties67 = item.properties) === null || _item$properties67 === void 0 ? void 0 : (_item$properties67$at = _item$properties67.attributes) === null || _item$properties67$at === void 0 ? void 0 : _item$properties67$at.tax_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Extra: ")]), (item === null || item === void 0 ? void 0 : (_item$properties68 = item.properties) === null || _item$properties68 === void 0 ? void 0 : (_item$properties68$at = _item$properties68.attributes) === null || _item$properties68$at === void 0 ? void 0 : _item$properties68$at.extra_tax_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties69 = item.properties) === null || _item$properties69 === void 0 ? void 0 : (_item$properties69$ol = _item$properties69.old) === null || _item$properties69$ol === void 0 ? void 0 : _item$properties69$ol.extra_tax_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties70 = item.properties) === null || _item$properties70 === void 0 ? void 0 : (_item$properties70$at = _item$properties70.attributes) === null || _item$properties70$at === void 0 ? void 0 : _item$properties70$at.extra_tax_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties71 = item.properties) === null || _item$properties71 === void 0 ? void 0 : (_item$properties71$at = _item$properties71.attributes) === null || _item$properties71$at === void 0 ? void 0 : _item$properties71$at.extra_tax_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("TAX Total: ")]), (item === null || item === void 0 ? void 0 : (_item$properties72 = item.properties) === null || _item$properties72 === void 0 ? void 0 : (_item$properties72$at = _item$properties72.attributes) === null || _item$properties72$at === void 0 ? void 0 : _item$properties72$at.total_tax_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties73 = item.properties) === null || _item$properties73 === void 0 ? void 0 : (_item$properties73$ol = _item$properties73.old) === null || _item$properties73$ol === void 0 ? void 0 : _item$properties73$ol.total_tax_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties74 = item.properties) === null || _item$properties74 === void 0 ? void 0 : (_item$properties74$at = _item$properties74.attributes) === null || _item$properties74$at === void 0 ? void 0 : _item$properties74$at.total_tax_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties75 = item.properties) === null || _item$properties75 === void 0 ? void 0 : (_item$properties75$at = _item$properties75.attributes) === null || _item$properties75$at === void 0 ? void 0 : _item$properties75$at.total_tax_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Grand Total: ")]), (item === null || item === void 0 ? void 0 : (_item$properties76 = item.properties) === null || _item$properties76 === void 0 ? void 0 : (_item$properties76$at = _item$properties76.attributes) === null || _item$properties76$at === void 0 ? void 0 : _item$properties76$at.grand_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties77 = item.properties) === null || _item$properties77 === void 0 ? void 0 : (_item$properties77$ol = _item$properties77.old) === null || _item$properties77$ol === void 0 ? void 0 : _item$properties77$ol.grand_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties78 = item.properties) === null || _item$properties78 === void 0 ? void 0 : (_item$properties78$at = _item$properties78.attributes) === null || _item$properties78$at === void 0 ? void 0 : _item$properties78$at.grand_amount))])] : [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$properties79 = item.properties) === null || _item$properties79 === void 0 ? void 0 : (_item$properties79$at = _item$properties79.attributes) === null || _item$properties79$at === void 0 ? void 0 : _item$properties79$at.grand_amount))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Milestones: ")]), (item === null || item === void 0 ? void 0 : (_item$properties80 = item.properties) === null || _item$properties80 === void 0 ? void 0 : (_item$properties80$at = _item$properties80.attributes) === null || _item$properties80$at === void 0 ? void 0 : _item$properties80$at.milestone) !== (item === null || item === void 0 ? void 0 : (_item$properties81 = item.properties) === null || _item$properties81 === void 0 ? void 0 : (_item$properties81$ol = _item$properties81.old) === null || _item$properties81$ol === void 0 ? void 0 : _item$properties81$ol.milestone) ? [_c('span', {
      staticClass: "text-danger"
    }, [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties82 = item.properties) === null || _item$properties82 === void 0 ? void 0 : (_item$properties82$at = _item$properties82.attributes) === null || _item$properties82$at === void 0 ? void 0 : _item$properties82$at.milestone))])])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties83 = item.properties) === null || _item$properties83 === void 0 ? void 0 : (_item$properties83$at = _item$properties83.attributes) === null || _item$properties83$at === void 0 ? void 0 : _item$properties83$at.milestone))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Extra: ")]), (item === null || item === void 0 ? void 0 : (_item$properties84 = item.properties) === null || _item$properties84 === void 0 ? void 0 : (_item$properties84$at = _item$properties84.attributes) === null || _item$properties84$at === void 0 ? void 0 : _item$properties84$at.extra_milestone) !== (item === null || item === void 0 ? void 0 : (_item$properties85 = item.properties) === null || _item$properties85 === void 0 ? void 0 : (_item$properties85$ol = _item$properties85.old) === null || _item$properties85$ol === void 0 ? void 0 : _item$properties85$ol.extra_milestone) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties86 = item.properties) === null || _item$properties86 === void 0 ? void 0 : (_item$properties86$at = _item$properties86.attributes) === null || _item$properties86$at === void 0 ? void 0 : _item$properties86$at.extra_milestone))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties87 = item.properties) === null || _item$properties87 === void 0 ? void 0 : (_item$properties87$at = _item$properties87.attributes) === null || _item$properties87$at === void 0 ? void 0 : _item$properties87$at.extra_milestone))])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Total: ")]), (item === null || item === void 0 ? void 0 : (_item$properties88 = item.properties) === null || _item$properties88 === void 0 ? void 0 : (_item$properties88$at = _item$properties88.attributes) === null || _item$properties88$at === void 0 ? void 0 : _item$properties88$at.total_milestone) !== (item === null || item === void 0 ? void 0 : (_item$properties89 = item.properties) === null || _item$properties89 === void 0 ? void 0 : (_item$properties89$ol = _item$properties89.old) === null || _item$properties89$ol === void 0 ? void 0 : _item$properties89$ol.total_milestone) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties90 = item.properties) === null || _item$properties90 === void 0 ? void 0 : (_item$properties90$at = _item$properties90.attributes) === null || _item$properties90$at === void 0 ? void 0 : _item$properties90$at.total_milestone))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties91 = item.properties) === null || _item$properties91 === void 0 ? void 0 : (_item$properties91$at = _item$properties91.attributes) === null || _item$properties91$at === void 0 ? void 0 : _item$properties91$at.total_milestone))])]], 2)], 1)], 1)], 1)], 1)], 1)])] : (item === null || item === void 0 ? void 0 : item.log_name) == 'milestones' && (item === null || item === void 0 ? void 0 : item.description) == 'created' ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "info"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', [_vm._v(" Milestone : "), _c('b-badge', {
      staticClass: "badge-glow",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties92 = item.properties) === null || _item$properties92 === void 0 ? void 0 : (_item$properties92$at = _item$properties92.attributes) === null || _item$properties92$at === void 0 ? void 0 : _item$properties92$at.title) + " ")]), _vm._v(" " + _vm._s("Created by ".concat(item === null || item === void 0 ? void 0 : (_item$properties93 = item.properties) === null || _item$properties93 === void 0 ? void 0 : (_item$properties93$at = _item$properties93.attributes) === null || _item$properties93$at === void 0 ? void 0 : (_item$properties93$at2 = _item$properties93$at.createdBy) === null || _item$properties93$at2 === void 0 ? void 0 : _item$properties93$at2.name)) + " ")], 1), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)))]), _c('span', {
      staticClass: "align-bottom"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at)))])])])] : (item === null || item === void 0 ? void 0 : item.log_name) == 'milestones' && (item === null || item === void 0 ? void 0 : item.description) == 'updated' ? [_c('app-timeline-item', {
      key: item === null || item === void 0 ? void 0 : item.id,
      attrs: {
        "icon": "InfoIcon",
        "variant": "info"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', [_vm._v(" Milestone : "), _c('b-badge', {
      staticClass: "badge-glow",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties94 = item.properties) === null || _item$properties94 === void 0 ? void 0 : (_item$properties94$at = _item$properties94.attributes) === null || _item$properties94$at === void 0 ? void 0 : _item$properties94$at.title) + " ")]), _vm._v(" " + _vm._s("updated by ".concat(item === null || item === void 0 ? void 0 : (_item$properties95 = item.properties) === null || _item$properties95 === void 0 ? void 0 : (_item$properties95$at = _item$properties95.attributes) === null || _item$properties95$at === void 0 ? void 0 : (_item$properties95$at2 = _item$properties95$at.updatedBy) === null || _item$properties95$at2 === void 0 ? void 0 : _item$properties95$at2.name)) + " ")], 1), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatYear(item === null || item === void 0 ? void 0 : item.created_at)))]), _c('span', {
      staticClass: "align-bottom"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : item.created_at)))]), _c('br'), _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: "milestone-change-list-".concat(item === null || item === void 0 ? void 0 : item.id),
        expression: "`milestone-change-list-${item?.id}`"
      }, {
        name: "ripple",
        rawName: "v-ripple.400",
        value: 'rgba(113, 102, 240, 0.15)',
        expression: "'rgba(113, 102, 240, 0.15)'",
        modifiers: {
          "400": true
        }
      }],
      staticClass: "mt-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      }
    }, [_vm._v(" Show Changes ")]), _c('b-collapse', {
      attrs: {
        "id": "milestone-change-list-".concat(item === null || item === void 0 ? void 0 : item.id)
      }
    }, [_c('b-row', {
      staticClass: "custom-font"
    }, [_c('b-col', {
      staticClass: "pr-1",
      attrs: {
        "cols": "6"
      }
    }, [_c('b-list-group', {
      staticClass: "mt-1",
      attrs: {
        "flush": ""
      }
    }, [_c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Previous")])])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Title:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties96 = item.properties) === null || _item$properties96 === void 0 ? void 0 : (_item$properties96$ol = _item$properties96.old) === null || _item$properties96$ol === void 0 ? void 0 : _item$properties96$ol.title))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Amount:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties97 = item.properties) === null || _item$properties97 === void 0 ? void 0 : (_item$properties97$ol = _item$properties97.old) === null || _item$properties97$ol === void 0 ? void 0 : _item$properties97$ol.amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("VAT Amount:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties98 = item.properties) === null || _item$properties98 === void 0 ? void 0 : (_item$properties98$ol = _item$properties98.old) === null || _item$properties98$ol === void 0 ? void 0 : _item$properties98$ol.vat_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("TAX Amount:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties99 = item.properties) === null || _item$properties99 === void 0 ? void 0 : (_item$properties99$ol = _item$properties99.old) === null || _item$properties99$ol === void 0 ? void 0 : _item$properties99$ol.tax_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Total Amount:")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties100 = item.properties) === null || _item$properties100 === void 0 ? void 0 : (_item$properties100$o = _item$properties100.old) === null || _item$properties100$o === void 0 ? void 0 : _item$properties100$o.grand_amount))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Deadline:")]), _vm._v(" " + _vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : (_item$properties101 = item.properties) === null || _item$properties101 === void 0 ? void 0 : (_item$properties101$o = _item$properties101.old) === null || _item$properties101$o === void 0 ? void 0 : _item$properties101$o.date)))])]), _c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Payment Type:")]), _vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties102 = item.properties) === null || _item$properties102 === void 0 ? void 0 : (_item$properties102$o = _item$properties102.old) === null || _item$properties102$o === void 0 ? void 0 : _item$properties102$o.payment_type)))])])], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('b-list-group', {
      staticClass: "mt-1",
      attrs: {
        "flush": ""
      }
    }, [_c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('span', [_c('b', [_vm._v("Updated")])])]), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties103 = item.properties) === null || _item$properties103 === void 0 ? void 0 : (_item$properties103$a = _item$properties103.attributes) === null || _item$properties103$a === void 0 ? void 0 : _item$properties103$a.title) !== (item === null || item === void 0 ? void 0 : (_item$properties104 = item.properties) === null || _item$properties104 === void 0 ? void 0 : (_item$properties104$o = _item$properties104.old) === null || _item$properties104$o === void 0 ? void 0 : _item$properties104$o.title) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties105 = item.properties) === null || _item$properties105 === void 0 ? void 0 : (_item$properties105$a = _item$properties105.attributes) === null || _item$properties105$a === void 0 ? void 0 : _item$properties105$a.title))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties106 = item.properties) === null || _item$properties106 === void 0 ? void 0 : (_item$properties106$a = _item$properties106.attributes) === null || _item$properties106$a === void 0 ? void 0 : _item$properties106$a.title) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties107 = item.properties) === null || _item$properties107 === void 0 ? void 0 : (_item$properties107$a = _item$properties107.attributes) === null || _item$properties107$a === void 0 ? void 0 : _item$properties107$a.amount) !== (item === null || item === void 0 ? void 0 : (_item$properties108 = item.properties) === null || _item$properties108 === void 0 ? void 0 : (_item$properties108$o = _item$properties108.old) === null || _item$properties108$o === void 0 ? void 0 : _item$properties108$o.amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties109 = item.properties) === null || _item$properties109 === void 0 ? void 0 : (_item$properties109$a = _item$properties109.attributes) === null || _item$properties109$a === void 0 ? void 0 : _item$properties109$a.amount))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties110 = item.properties) === null || _item$properties110 === void 0 ? void 0 : (_item$properties110$a = _item$properties110.attributes) === null || _item$properties110$a === void 0 ? void 0 : _item$properties110$a.amount) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("VAT Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties111 = item.properties) === null || _item$properties111 === void 0 ? void 0 : (_item$properties111$a = _item$properties111.attributes) === null || _item$properties111$a === void 0 ? void 0 : _item$properties111$a.vat_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties112 = item.properties) === null || _item$properties112 === void 0 ? void 0 : (_item$properties112$o = _item$properties112.old) === null || _item$properties112$o === void 0 ? void 0 : _item$properties112$o.vat_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties113 = item.properties) === null || _item$properties113 === void 0 ? void 0 : (_item$properties113$a = _item$properties113.attributes) === null || _item$properties113$a === void 0 ? void 0 : _item$properties113$a.vat_amount))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties114 = item.properties) === null || _item$properties114 === void 0 ? void 0 : (_item$properties114$a = _item$properties114.attributes) === null || _item$properties114$a === void 0 ? void 0 : _item$properties114$a.vat_amount) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("TAX Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties115 = item.properties) === null || _item$properties115 === void 0 ? void 0 : (_item$properties115$a = _item$properties115.attributes) === null || _item$properties115$a === void 0 ? void 0 : _item$properties115$a.tax_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties116 = item.properties) === null || _item$properties116 === void 0 ? void 0 : (_item$properties116$o = _item$properties116.old) === null || _item$properties116$o === void 0 ? void 0 : _item$properties116$o.tax_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties117 = item.properties) === null || _item$properties117 === void 0 ? void 0 : (_item$properties117$a = _item$properties117.attributes) === null || _item$properties117$a === void 0 ? void 0 : _item$properties117$a.tax_amount))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties118 = item.properties) === null || _item$properties118 === void 0 ? void 0 : (_item$properties118$a = _item$properties118.attributes) === null || _item$properties118$a === void 0 ? void 0 : _item$properties118$a.tax_amount) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Total Amount: ")]), (item === null || item === void 0 ? void 0 : (_item$properties119 = item.properties) === null || _item$properties119 === void 0 ? void 0 : (_item$properties119$a = _item$properties119.attributes) === null || _item$properties119$a === void 0 ? void 0 : _item$properties119$a.grand_amount) !== (item === null || item === void 0 ? void 0 : (_item$properties120 = item.properties) === null || _item$properties120 === void 0 ? void 0 : (_item$properties120$o = _item$properties120.old) === null || _item$properties120$o === void 0 ? void 0 : _item$properties120$o.grand_amount) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties121 = item.properties) === null || _item$properties121 === void 0 ? void 0 : (_item$properties121$a = _item$properties121.attributes) === null || _item$properties121$a === void 0 ? void 0 : _item$properties121$a.grand_amount))])] : [_c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$properties122 = item.properties) === null || _item$properties122 === void 0 ? void 0 : (_item$properties122$a = _item$properties122.attributes) === null || _item$properties122$a === void 0 ? void 0 : _item$properties122$a.grand_amount) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Deadline: ")]), (item === null || item === void 0 ? void 0 : (_item$properties123 = item.properties) === null || _item$properties123 === void 0 ? void 0 : (_item$properties123$a = _item$properties123.attributes) === null || _item$properties123$a === void 0 ? void 0 : _item$properties123$a.date) !== (item === null || item === void 0 ? void 0 : (_item$properties124 = item.properties) === null || _item$properties124 === void 0 ? void 0 : (_item$properties124$o = _item$properties124.old) === null || _item$properties124$o === void 0 ? void 0 : _item$properties124$o.date) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : (_item$properties125 = item.properties) === null || _item$properties125 === void 0 ? void 0 : (_item$properties125$a = _item$properties125.attributes) === null || _item$properties125$a === void 0 ? void 0 : _item$properties125$a.date)))])] : [_c('span', [_vm._v(" " + _vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : (_item$properties126 = item.properties) === null || _item$properties126 === void 0 ? void 0 : (_item$properties126$a = _item$properties126.attributes) === null || _item$properties126$a === void 0 ? void 0 : _item$properties126$a.date)) + " ")])]], 2), _c('b-list-group-item', {
      staticClass: "justify-content-between align-items-center bg-transparent"
    }, [_c('b', [_vm._v("Payment Type: ")]), (item === null || item === void 0 ? void 0 : (_item$properties127 = item.properties) === null || _item$properties127 === void 0 ? void 0 : (_item$properties127$a = _item$properties127.attributes) === null || _item$properties127$a === void 0 ? void 0 : _item$properties127$a.payment_type) !== (item === null || item === void 0 ? void 0 : (_item$properties128 = item.properties) === null || _item$properties128 === void 0 ? void 0 : (_item$properties128$o = _item$properties128.old) === null || _item$properties128$o === void 0 ? void 0 : _item$properties128$o.payment_type) ? [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties129 = item.properties) === null || _item$properties129 === void 0 ? void 0 : (_item$properties129$a = _item$properties129.attributes) === null || _item$properties129$a === void 0 ? void 0 : _item$properties129$a.payment_type)))])] : [_c('span', [_vm._v(" " + _vm._s(_vm.formatType(item === null || item === void 0 ? void 0 : (_item$properties130 = item.properties) === null || _item$properties130 === void 0 ? void 0 : (_item$properties130$a = _item$properties130.attributes) === null || _item$properties130$a === void 0 ? void 0 : _item$properties130$a.payment_type)) + " ")])]], 2)], 1)], 1)], 1)], 1)], 1)])] : _vm._e()];
  })], 2)], 1)], 1)])], 1)], 1)], 2)], 1), _c('b-modal', {
    attrs: {
      "id": "edit-key-account-manager",
      "centered": "",
      "title": "Edit Key Account Manager",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "editKeyAccountManagerValidationForm"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.editKeyAccountManagerValidationForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Key Account Manager",
      "label-for": "kam"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "key account manager",
      "vid": "kam"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref21) {
        var errors = _ref21.errors;
        return [_c('v-select', {
          attrs: {
            "id": "kam",
            "placeholder": "Select Employee",
            "options": _vm.userIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('div', {
                staticClass: "d-flex align-items-center"
              }, [_c('b-avatar', {
                staticClass: "mr-1",
                attrs: {
                  "src": (data === null || data === void 0 ? void 0 : data.avatar) === '' ? '/avatar.svg' : data === null || data === void 0 ? void 0 : data.avatar
                }
              }), _c('div', [_c('div', {
                staticClass: "font-weight-bolder"
              }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : data.name) + " "), _c('b-badge', {
                attrs: {
                  "pill": "",
                  "variant": "warning"
                }
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.employee_number))])], 1), _c('div', {
                staticClass: "font-small-2"
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.email))])])], 1)];
            }
          }], null, true),
          model: {
            value: _vm.kam,
            callback: function callback($$v) {
              _vm.kam = $$v;
            },
            expression: "kam"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }